export const THEMES = {
    SWGE: 'swge'
};
